import React, { useMemo, useState } from "react"
import { useDispatch } from "react-redux"
import { useHistory } from "react-router-dom"
import { COLORS } from "../../../utilities/Constants"
import { generalStyles as gs } from "../../styles/styles"
import CustomModal from "../../basics/interface/CustomModal"

const adrLabel = (a) =>
	`${a.numero || ""} ${a.rue || ""} ${a.code_postal || ""} ${a.localite || ""}`
		.replace(/\s+/g, " ")
		.trim() || "Adresse"

// Crée une fiche location pré-remplie depuis un client (adresse au choix).
// Reprend le workflow legacy : SET_LOCATION_ENTITE_VEHICULE + /location/fiche/0.
const ClientToLocationModalV2 = ({ entite, onClose }) => {
	const dispatch = useDispatch()
	const history = useHistory()
	const savedAdresses = useMemo(
		() => (entite.adresses || []).filter((a) => a.id != null),
		[entite.adresses],
	)
	const [selAdr, setSelAdr] = useState(savedAdresses.length === 1 ? 0 : -1)

	const create = () => {
		const adresse = savedAdresses[selAdr]
		dispatch({
			type: "SET_LOCATION_ENTITE_VEHICULE",
			value: { entite, adresse: adresse.id },
		})
		history.push("/location/fiche/0")
	}

	const noAdresse = savedAdresses.length === 0

	return (
		<CustomModal
			title="Nouvelle fiche location"
			subtitle={entite.label || `${entite.prenom || ""} ${entite.nom || ""}`.trim()}
			onClose={onClose}
			buttons={
				noAdresse
					? [{ title: "Fermer", styleName: "secondary", onClick: onClose }]
					: [
							{
								title: "Annuler",
								styleName: "secondary",
								onClick: onClose,
							},
							{
								title: "Créer",
								styleName: "primary",
								onClick: create,
								disabled: selAdr === -1,
							},
						]
			}
		>
			{noAdresse ? (
				<p style={{ margin: 0, fontSize: 13, color: COLORS.textMuted }}>
					Aucune adresse enregistrée pour ce client.
				</p>
			) : (
				<div style={gs.fieldGroup}>
					<div style={gs.fieldRow}>
						<label style={gs.label}>Adresse de facturation</label>
						{savedAdresses.length > 1 ? (
							<select
								style={gs.input}
								value={selAdr}
								onChange={(e) =>
									setSelAdr(parseInt(e.target.value))
								}
							>
								<option value={-1}>—</option>
								{savedAdresses.map((a, i) => (
									<option key={a.id} value={i}>
										{adrLabel(a)}
									</option>
								))}
							</select>
						) : (
							<span style={{ fontSize: 13, color: COLORS.text }}>
								{adrLabel(savedAdresses[0])}
							</span>
						)}
					</div>
				</div>
			)}
		</CustomModal>
	)
}

export default ClientToLocationModalV2
